// extracted by mini-css-extract-plugin
export var modal = "_tv-0";
export var table = "_tv-1";